import React, { useContext, useEffect } from "react";
import { CounterCtx } from "../context/context";
import { STYLE_MASTER_SATU_BUNDLE } from "./helpers";
import { Grid, Paper } from "@material-ui/core";
import useReloadTableKunjungan from "./hooks/useReloadTableKunjungan";
import CounterKunjunganTable from "./CounterKunjunganTable";
import { isNull, today } from "App/utils/helpers";
import {
	InputOptionMaster,
	InputReactDatepicker,
	InputTextMaster,
	LabelRequired,
	MasterButton,
} from "App/Component/ui";
import { useSelector } from "react-redux";

function CounterKunjungan() {
	const { state } = useContext(CounterCtx);
	const rows = state.kunjungan.data;
	const totalData = state.kunjungan.count;

	const master = useSelector(({ master }) => master);
	const dokterList = master.dokter.list_select;

	const classes = STYLE_MASTER_SATU_BUNDLE();

	const {
		resetPagination,
		setNewData,
		pagination,
		onPrevious,
		onNext,
		handleClickPageNumber,
		handleChangeLimit,
		loading,
		formFilter,
		handleChange,
		setFormFilter,
	} = useReloadTableKunjungan();

	useEffect(() => {
		setNewData(1, 10, {
			id_kunjungan: formFilter.id_kunjungan,
			id_dokter: formFilter.id_dokter,
			no_rm: formFilter.no_rm,
			nama_pasien: formFilter.nama_pasien,
			tglAwal: today(true),
			tglAkhir: today(true),
		});
	}, []);

	const handleSelect = (rows) => {
		console.log("hehe : ", rows);
	};

	const handleClickSearch = () => {
		setNewData(1, 10, {
			id_kunjungan: formFilter.id_kunjungan,
			id_dokter: formFilter.id_dokter,
			no_rm: formFilter.no_rm,
			nama_pasien: formFilter.nama_pasien,
			tglAwal: formFilter.tglAwal,
			tglAkhir: formFilter.tglAkhir,
		});
	};

	return (
		<>
			<div className="mb-2">
				<Paper className={classes.paper}>
					<Grid
						container
						direction="row"
						spacing={1}
						alignItems="center"
						justifyContent="space-between"
					>
						<Grid item md={6}>
							<h4>Semua Kunjungan</h4>
						</Grid>
					</Grid>

					<div className="mb-1">
						<Grid container direction="row" spacing={1}>
							<Grid item md={3}>
								<InputReactDatepicker
									selected={formFilter.tglAwal}
									label="TANGGAL MULAI"
									handleChangeToday={(e) =>
										setFormFilter({
											...formFilter,
											tglAwal: e,
										})
									}
									onChange={(e) =>
										setFormFilter({
											...formFilter,
											tglAwal: e,
										})
									}
								/>
							</Grid>
							<Grid item md={3}>
								<InputReactDatepicker
									selected={formFilter.tglAkhir}
									label="TANGGAL SELESAI"
									handleChangeToday={(e) =>
										setFormFilter({
											...formFilter,
											tglAkhir: e,
										})
									}
									onChange={(e) =>
										setFormFilter({
											...formFilter,
											tglAkhir: e,
										})
									}
								/>
							</Grid>
							<Grid item md={3}>
								<InputTextMaster
									name="id_kunjungan"
									label={<LabelRequired label="ID KUNJUNGAN" />}
									id="id_kunjungan"
									placeholder="ID KUNJUNGAN"
									value={formFilter.id_kunjungan}
									onChange={handleChange("id_kunjungan")}
								/>
							</Grid>
							<Grid item md={3}>
								<InputTextMaster
									name="no_rm"
									label={<LabelRequired label="NO. RM" />}
									id="no_rm"
									placeholder="NO. RM"
									value={formFilter.no_rm}
									onChange={handleChange("no_rm")}
								/>
							</Grid>
							<Grid item md={3}>
								<InputTextMaster
									name="nama_pasien"
									label={<LabelRequired label="NAMA PASIEN" />}
									id="nama_pasien"
									placeholder="NAMA PASIEN"
									value={formFilter.nama_pasien}
									onChange={handleChange("nama_pasien")}
								/>
							</Grid>
							<Grid item md={3}>
								<InputOptionMaster
									name="dokter"
									label="DOKTER"
									id="dokter"
									data={dokterList}
									withSearch={true}
									value={formFilter.id_dokter}
									labelValue={formFilter.nama_dokter}
									onChange={(e) => {
										if (isNull(e)) {
											setFormFilter({
												...formFilter,
												id_dokter: null,
												nama_dokter: "Pilih Dokter",
											});
										} else {
											setFormFilter({
												...formFilter,
												id_dokter: e?.value,
												nama_dokter: e?.label,
											});
										}
									}}
								/>
							</Grid>
						</Grid>

						<Grid
							container
							spacing={1}
							alignItems="flex-end"
							justifyContent="flex-end"
						>
							<div
								style={{
									display: "flex",
									alignItems: "flex-end",
									justifyContent: "flex-end",
									marginTop: "14px",
								}}
							>
								<MasterButton
									type="submit"
									size="md"
									color={"lightgreen"}
									name={"Cari"}
									onClick={() => handleClickSearch()}
								/>
							</div>
						</Grid>
					</div>

					<CounterKunjunganTable
						rows={rows}
						handleSelect={handleSelect}
						totalData={totalData}
						resetPagination={resetPagination}
						setNewData={setNewData}
						pagination={pagination}
						onPrevious={onPrevious}
						onNext={onNext}
						handleClickPageNumber={handleClickPageNumber}
						handleChangeLimit={handleChangeLimit}
						loading={loading}
						handleChange={handleChange}
						formFilter={formFilter}
						setFormFilter={setFormFilter}
					/>
				</Paper>
			</div>
		</>
	);
}

export default CounterKunjungan;
